<template>
    <div class="about">
      <div class="aboutInner">
        <div class="dyBlock" v-for="(item, index) in titleList" :key="item.name">
          <div class="BlockTit">{{item.name}}</div>
          <div class="name" v-for="cItem in item.children" :key="cItem.topTitle" @click="toDetails(cItem.id, index, cItem.path)">{{cItem.topTitle}}</div>
        </div>
        <div>
          <div class="BlockTit">
            友情链接</div>
          <div class="name" v-for="item in linkData" :key="item.linkName">
            <a :href="item.linkUrl" target="_blank">
             {{item.linkName}}
            </a>
          </div>
        </div>
        <div>
          <div class="BlockTit">
            联系我们</div>
          <div class="name">联系电话：0351-2196162、0351-6366777</div>
          <div class="name">邮箱：office@sice-tsinghua.org、sxsgyhlwxh@163.com</div>
          <!-- <div class="name">地址：山西转型综合改革示范区科技创<br />新城正阳街100号</div> -->
        </div>
      </div>
      <div style="position: absolute;bottom: 20px;font-size: 16px;font-family: PingFang SC;font-weight: 400;color: #A0AEC1;line-height: 36px;">
        <a href="https://beian.miit.gov.cn/"  target="_blank" style="color: #A0AEC1;">版权所有©️山西省工业互联网协会 <span class="split">|</span> 备案号 晋ICP备2022007665号-1</a></div>
    </div>
</template>
<script>
  import {
    getLinkData,
    fetchWebsiteInfo,
    getJJFAData,
    getApplicationData,
  } from '@/api/api'
  export default {
    data() {
      return {
        linkData:[], // 友情链接
        websiteInfo: null,
        titleList:[
          {
            name: '标识解析',
            children: [
            {
              topTitle: '二级节点',
              path: '/SecondaryNode'
            }, {
              topTitle: '企业节点',
              path: '/CompanyNode'
            },
            ]
          },
          {
            name: '应用市场',
            id: 'market',
            children: [{
              topTitle: '码客通',
            }, {
              topTitle: '多码合一',
            }, {
              topTitle: '任意贴',
            }, {
              topTitle: '防伪',
            }, {
              topTitle: '防窜货',
            }, {
              topTitle: '易客展示屏',
            }, {
              topTitle: '智慧瓶盖',
            }]
          },
          {
            name: '解决方案',
            id: 'solution',
            children: [{
              name: '产品溯源管理',
              path: '',
            }, {
              name: '车辆物流管理',
              path: '',
            }, {
              name: '防窜货管理',
              path: '',
            }, {
              name: '防伪系统管理',
              path: '',
            }, {
              name: '供应链管理',
              path: '',
            }, {
              name: '智能产品全生命周期管理',
              path: '',
            }, {
              name: '人员生产安全',
              path: '',
            }, {
              name: '设备预测性运维',
              path: '',
            }, {
              name: '设备状态监测',
              path: '',
            }, {
              name: '设备资产管理',
              path: '',
            }]
          }
        ]
      }
    },
    created() {

      this.getYYData()
      this.setJJFAData()
      this.getWebsiteInfo()
      this.getLink()
    },
    methods:{
      getYYData() {
        let params={
          page: 0,
          size: 100,
        }
        getApplicationData(params).then(res => {
          res.data.content.map((item, index)=> {
            this.$set(this.titleList[1].children, [index], {'topTitle': item.title, 'id': item.id})
          })
        })
      },
      setJJFAData() {
        getJJFAData().then(res => {
          this.titleList[2].children = res.data.content
        })
      },
      getWebsiteInfo() {
        fetchWebsiteInfo().then(res => {
          this.websiteInfo = res.data
        })
      },
      getLink() {
        getLinkData().then(res => {
          this.linkData = res.data
        })
      },
      toDetails(id, index, path) {
        console.log('1',id)
        console.log('2',index)
        console.log('3',path)
        if (index == 0) {
          this.$router.push({
            path: path
          })
        }else if(index == 1) {
          this.$router.push({
            path: '/marketdetails',
            query: {
              data: id
            },
          })
        }else if(index == 2) {
          this.$router.push({
            path: '/DetailsPage',
            query: {
              data: id
            },
          })
        }
      },
    }
  }
</script>
<style scoped>
  .about{
    width: 100%;
    height: 550px;
    background: #1C2633;
    padding-top: 76px;
    position: relative;
    display: flex;
    justify-content: center
    ;box-sizing: border-box;
  }
  .about .name {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #A0AEC1;
    line-height: 36px;
  }
  .about .name a {
    color: #A0AEC1;
  }
  .about .name a:hover{
    color: #fff;
  }
  .dyBlock .name:hover{
    color: #fff;
    cursor: pointer;
  }
  .BlockTit{
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 36px;
  }
  .aboutInner{
    width: 1373px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue